import React from 'react'

class NotificationBell extends React.Component {
  render() {
    return (
      <svg
        className="icon notificationBell"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <g fill="none" fillRule="evenodd">
          <g fillRule="nonzero" stroke="#FFFFFF" strokeWidth="2">
            <path d="M15 28.436c-1.96 0-3.549-1.571-3.549-3.51h7.097c0 1.939-1.589 3.51-3.548 3.51z" />
            <path d="M26.99 23.545c0 1.297-1.063 1.383-2.374 1.383H5.383c-1.312 0-2.374-.086-2.374-1.383v-.224c0-.933.554-1.732 1.35-2.111.146-1.55.397-3.696.754-6.436.535-4.11 3.369-8.644 7.854-9.571V3.99c0-1.11.91-2.011 2.034-2.011 1.123 0 2.033.9 2.033 2.011v1.213c4.485.927 7.28 5.355 7.854 9.571.382 2.811.633 4.957.754 6.437a2.34 2.34 0 0 1 1.35 2.11l-.001.224z" />
          </g>
        </g>
      </svg>
    )
  }
}

export default NotificationBell
